import APIService from '../api.service';

export const FetchUomList = (payload) => {
  return APIService.get(`/v01/uoms`, {
    params: {
      ...payload,
    },
  });
};

export const CreateUom = (body, config = {}) => {
  return APIService.post(`/v01/uoms`, body, config);
};

export const UpdateUom = (payload) => {
  const id = payload.id;
  return APIService.put(`/v01/uoms/${id}`, {
    ...payload,
  });
};

export const DeleteUom = (id) => {
  return APIService.delete(`/v01/uoms/${id}`);
};

export const AllUom = () => {
  return APIService.get(`/v01/uoms-all`);
};

const UomService = {
  FetchUomList,
  CreateUom,
  UpdateUom,
  DeleteUom,
  AllUom,
};

export default UomService;
